const NAME = "FISCALIZATION";

export default NAME;
